import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './Icon';
export function CancelIcon(props) {
  var size = props.size,
      color = props.color,
      hoverColor = props.hoverColor,
      focusColor = props.focusColor;
  return React.createElement(Icon, {
    size: size,
    color: color,
    hoverColor: hoverColor,
    focusColor: focusColor
  }, React.createElement("svg", {
    style: {
      fill: 'currentColor',
      maxHeight: "100%",
      maxWidth: "100%",
      height: "100%",
      width: "100%"
    },
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, React.createElement("defs", null, React.createElement("path", {
    d: "M13.65,2.35 C10.5166667,-0.783333333 5.45,-0.783333333 2.35,2.35 C-0.783333333,5.48333333 -0.783333333,10.55 2.35,13.65 C5.48333333,16.7833333 10.55,16.7833333 13.65,13.65 C16.75,10.55 16.75,5.48333333 13.65,2.35 L13.65,2.35 Z M10.8166667,10.85 C10.55,11.1166667 10.15,11.1166667 9.88333333,10.85 L7.98333333,8.95 L6.08333333,10.85 C5.81666667,11.1166667 5.41666667,11.1166667 5.15,10.85 C4.88333333,10.5833333 4.88333333,10.1833333 5.15,9.91666667 L7.05,8.01666667 L5.15,6.11666667 C4.88333333,5.85 4.88333333,5.45 5.15,5.18333333 C5.41666667,4.91666667 5.81666667,4.91666667 6.08333333,5.18333333 L7.98333333,7.08333333 L9.88333333,5.18333333 C10.15,4.91666667 10.55,4.91666667 10.8166667,5.18333333 C11.0833333,5.45 11.0833333,5.85 10.8166667,6.11666667 L8.91666667,8.01666667 L10.8166667,9.91666667 C11.0833333,10.1833333 11.0833333,10.5833333 10.8166667,10.85 L10.8166667,10.85 Z",
    id: "a"
  })), React.createElement("g", {
    fillRule: "evenodd"
  }, React.createElement("mask", {
    id: "b"
  }, React.createElement("use", {
    xlinkHref: "#a"
  })), React.createElement("use", {
    xlinkHref: "#a"
  }), React.createElement("g", {
    mask: "url(#b)"
  }, React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "rotate(180 8 8)"
  })))));
}
CancelIcon.displayName = 'CancelIcon';
CancelIcon.defaultProps = {
  size: 24,
  color: 'brand'
};
var validColorPropValues = PropTypes.oneOf(['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 's1', 's1-washed', 's1-burned', 's2', 's2-washed', 's2-burned', 's3', 's3-washed', 's3-burned', 's4', 's4-washed', 's4-burned', 's5', 's5-washed', 's5-burned', 'danger', 'danger-washed', 'danger-burned', 'warning', 'warning-washed', 'warning-burned', 'success', 'success-washed', 'success-burned', 'brand', 'brand-washed', 'brand-burned']);
CancelIcon.propTypes = {
  size: PropTypes.number,
  color: validColorPropValues,
  hoverColor: validColorPropValues,
  focusColor: validColorPropValues
};